export default function ConvertDecimalToHex(color){
    return `#${color.toString(16)}`;
}
